import { Icon } from "@iconify/react";
import { useEffect, useState, useMemo } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import plusFill from "@iconify/icons-eva/plus-fill";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch, Button, Select, MenuItem, Grid, TextField, FormControl, InputLabel } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Confirm from "src/components/common/ConfirmDialog";
import CellImage from "src/components/common/CellImage";
import { asyncRequest } from "src/services/network";
import MerchantInfo from "src/components/common/MerchantInfo";
import { useSelector } from "react-redux";
import ProductEdit from "./components/ProductEdit";
import { getLowestPrice } from "src/utils/util";
import { getSuppliers, getStoreSections } from "src/services/request";
import SupplierPicker from "src/components/common/SupplierPicker";

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false },
  { id: "sectionId", label: "所属区域", alignRight: false },
  { id: "supplierId", label: "所属供应商", alignRight: false },
  { id: "cover", label: "封面", alignRight: false },
  { id: "name", label: "商品名称", alignRight: false },
  { id: "merchant", label: "所属商户", alignRight: false },
  { id: "price", label: "售价", alignRight: false },
  // { id: "points", label: "用户积分", alignRight: false },
  // { id: "pointsMer", label: "商家积分", alignRight: false },
  { id: "buyCount", label: "销量", alignRight: false },
  { id: "stock", label: "库存", alignRight: false },
  { id: "isShow", label: "上/下架", alignRight: false },
  { id: "order", label: "排序", alignRight: false },
  { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "操作" },
];

const moreMenus = [
  { title: "编辑", icon: iconEdit2 },
  { title: "删除", icon: iconEdit2 },
];

export default function MerchantProductList() {
  const { sectionMap, supplierMap, storeSections } = useSelector((state) => state.globalData);
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [categoryIdList, setCategoryIdList] = useState([]);
  const [categories, setCategories] = useState([]); // 扁平化但带层级信息
  // 在组件内添加状态
  const [categorySearch, setCategorySearch] = useState('');
  const [openCategorySelect, setOpenCategorySelect] = useState(false);
  const [total, setTotal] = useState(0);

  const [action, setAction] = useState("");
  const [targetItem, setTargetItem] = useState({});

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
    supplierId: null,
    categoryId:"",
    subCategoryId: "",   // 二级分类
    status: "",
  });

  useEffect(() => {
    getSuppliers();
    getStoreSections();
    getProductCategories()
  }, []);

  useEffect(() => {
    getItems();
  }, [filter]);
  // 添加过滤后的分类数据
  const filteredCategories = useMemo(() => {
    if (!categorySearch.trim()) {
      return categories;
    }

    const searchTerm = categorySearch.toLowerCase();
    return categories.filter(category =>
      category.name.toLowerCase().includes(searchTerm) ||
      category.displayName.toLowerCase().includes(searchTerm)
    );
  }, [categories, categorySearch]);
  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/store/product/list",
      data: filter,
    });

    setItems(
      data.map((d) => {
        const extra = {};
        if (d.specType == 1) {
          const priceItem = getLowestPrice(d.priceList);
          extra.price = parseFloat(priceItem.price); //  + '起'
          extra.points = parseFloat(priceItem.points);
        }
        return {
          ...d,
          ...extra,
        };
      })
    );
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleFilterChange = (ki, val) => {
    setFilter({
      ...filter,
      [ki]: val,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`/product/edit/${row.id}`, { state: row });
      setTargetItem(row);
      setAction("edit");
    } else if (type === "删除") {
      handleDel(row);
    }
  };

  async function toggleEnabled(formData) {
    await asyncRequest({
      path: "/store/product/toggleEnabled",
      data: formData,
    });

    getItems();
  }

  function handleDel({ id }) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      onConfirm() {
        axios
          .post("/store/product/del", { id })
          .then((res) => {
            const { code, msg, data } = res.data;
            if (code === 1) {
              setItems(items.filter((b) => b.id !== id));
            } else {
              alert(msg);
            }
          })
          .catch((err) => {
            console.log("删除商品失败: ", err);
          });
      },
    });
  }
  async function getProductCategories () {
    try {
      const response = await axios.get("/store/category/all");
      const { code, data } = response.data;
      if (code === 1) {
        // 方法1：先构建树再扁平化
        const buildTree = (items, parentId = 0, level = 0) => {
          return items
            .filter(item => item.pid === parentId)
            .sort((a, b) => b.order - a.order)
            .flatMap(item => [
              {
                ...item,
                level,
                displayName: `${"─".repeat(level * 2)} ${item.name}`.trimStart()
              },
              ...buildTree(items, item.id, level + 1)
            ]);
        };
        setCategories(buildTree(data));
      }
    } catch (err) {
      console.error("获取分类失败:", err);
    }
  };
  const isUserNotFound = items.length === 0;

  return (
    <Page title="产品列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            产品列表
          </Typography>

          <Button
            variant="contained"
            startIcon={<Icon icon={plusFill} />}
            onClick={() => {
              setTargetItem({});
              setAction("add");
            }}
          >
            添加产品
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems}>
            <Grid container gap={2}>
              <Grid item>
                <TextField
                  style={{ width: 200 }}
                  label="名称"
                  placeholder="名称"
                  autoComplete="off"
                  id="name"
                  size="small"
                  value={filter.name}
                  onChange={(e) => {
                    handleFilterChange("name", e.target.value);
                  }}
                />
              </Grid>

              <Grid item>
                <TextField
                  style={{ width: 200 }}
                  label="供应商"
                  placeholder="供应商"
                  autoComplete="off"
                  id="supplierId"
                  size="small"
                  value={filter.supplierId}
                  onClick={() => {
                    SupplierPicker({
                      onSelect(val) {
                        handleFilterChange("supplierId", val.id);
                      },
                    });
                  }}
                />
              </Grid>

              {/* <Grid item>
                <FormControl size="small">
                  <InputLabel>状态</InputLabel>
                  <Select
                    label="状态"
                    value={PAYMENT_STATUS_MAP[filter.status]}
                    onChange={(e) => {
                      handleFilterChange("status", e.target.value);
                    }}
                    style={{ width: 250 }}
                  >
                    {statuses.map((status, idx) => (
                      <MenuItem key={idx} value={status} name={status}>
                        {PAYMENT_STATUS_MAP[status]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              {/* <Grid item>
                <MyDateRangePicker
                  value={filter.createdAt}
                  onChange={(val) => {
                    handleFilterChange("createdAt", val);
                  }}
                />
              </Grid> */}

              <Grid item>
                <FormControl size="small">
                  <InputLabel id="version">专区</InputLabel>
                  <Select label="专区" value={filter.sectionId} onChange={(e) => handleFilterChange("sectionId", e.target.value)} style={{ width: 250, height: 44 }}>
                    {storeSections.map((section, idx) => (
                      <MenuItem key={section.id} value={section.id} name={section.name}>
                        {section.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl size="small" style={{ width: 150 }}>
                  <InputLabel>上/下架</InputLabel>
                  <Select label="上/下架" value={filter.status} onChange={(e) => handleFilterChange("status", e.target.value)}>
                    <MenuItem value="">全部</MenuItem>
                    <MenuItem value={1}>上架</MenuItem>
                    <MenuItem value={0}>下架</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {/* <Grid item>
                <FormControl size="small">
                  <InputLabel>商品分类</InputLabel>
                  <Select
                    key={`${filter.categoryId}-${filter.subCategoryId}`} // 添加 key 强制重新渲染
                    label="商品分类"
                    value={filter.subCategoryId || filter.categoryId || ""}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      console.log("选择的ID:", selectedId, "类型:", typeof selectedId);

                      // 清空选择
                      if (!selectedId) {
                        setFilter(prev => ({
                          ...prev,
                          categoryId: "",
                          subCategoryId: ""
                        }));
                        return;
                      }

                      // 转换为数字以确保类型一致
                      const idNum = Number(selectedId);
                      const selectedCategory = categories.find(cat => cat.id === idNum);
                      console.log("找到的分类:", selectedCategory);

                      if (selectedCategory?.level === 0) {
                        console.log("一级分类:", selectedCategory.id);
                        setFilter(prev => ({
                          ...prev,
                          categoryId: idNum,
                          subCategoryId: ""
                        }));
                      } else if (selectedCategory?.level === 1) {
                        console.log("二级分类:", selectedCategory.id);
                        const parentCategory = categories.find(cat => cat.id === selectedCategory.pid);
                        console.log("父级分类:", parentCategory);
                        setFilter(prev => ({
                          ...prev,
                          categoryId: parentCategory?.id || "",
                          subCategoryId: idNum
                        }));
                      } else {
                        console.log("其他情况");
                        setFilter(prev => ({
                          ...prev,
                          categoryId: "",
                          subCategoryId: ""
                        }));
                      }
                    }}
                    style={{ width: 250, height: 44 }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300
                        }
                      }
                    }}
                  >
                    <MenuItem value="">全部</MenuItem>
                    {categories.map(category => (
                      <MenuItem
                        key={category.id}
                        value={String(category.id)} // 确保值为字符串
                        style={{
                          paddingLeft: 20 + category.level * 20,
                          fontWeight: category.level === 0 ? 'bold' : 'normal'
                        }}
                      >
                        {category.displayName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}
              <Grid item>
                <FormControl size="small" style={{ width: 250 }}>
                  <InputLabel>商品分类</InputLabel>
                  <Select
                    label="商品分类"
                    value={filter.subCategoryId || filter.categoryId || ""}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      console.log("选择的ID:", selectedId);

                      if (!selectedId) {
                        setFilter(prev => ({
                          ...prev,
                          categoryId: "",
                          subCategoryId: ""
                        }));
                        setCategorySearch(''); // 清空搜索
                        return;
                      }

                      const idNum = Number(selectedId);
                      const selectedCategory = categories.find(cat => cat.id === idNum);
                      console.log("找到的分类:", selectedCategory);

                      if (selectedCategory?.level === 0) {
                        console.log("一级分类:", selectedCategory.id);
                        setFilter(prev => ({
                          ...prev,
                          categoryId: idNum,
                          subCategoryId: ""
                        }));
                      } else if (selectedCategory?.level === 1) {
                        console.log("二级分类:", selectedCategory.id);
                        const parentCategory = categories.find(cat => cat.id === selectedCategory.pid);
                        console.log("父级分类:", parentCategory);
                        setFilter(prev => ({
                          ...prev,
                          categoryId: parentCategory?.id || "",
                          subCategoryId: idNum
                        }));
                      } else {
                        console.log("其他情况");
                        setFilter(prev => ({
                          ...prev,
                          categoryId: "",
                          subCategoryId: ""
                        }));
                      }

                      setCategorySearch(''); // 选择后清空搜索
                      setOpenCategorySelect(false); // 关闭下拉
                    }}
                    open={openCategorySelect}
                    onOpen={() => {
                      setOpenCategorySelect(true);
                      setCategorySearch(''); // 打开时清空搜索
                    }}
                    onClose={() => {
                      setOpenCategorySelect(false);
                      setCategorySearch(''); // 关闭时清空搜索
                    }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300
                        }
                      },
                      // 阻止点击搜索框时关闭下拉
                      disableAutoFocusItem: true,
                      // 自定义菜单内容
                      MenuListProps: {
                        autoFocus: false
                      }
                    }}
                    renderValue={(selected) => {
                      if (!selected) return "全部";
                      const selectedCategory = categories.find(cat =>
                        cat.id === Number(selected)
                      );
                      return selectedCategory ? selectedCategory.displayName : selected;
                    }}
                  >
                    {/* 自定义下拉菜单内容 */}
                    <div
                      style={{
                        padding: '8px 16px',
                        borderBottom: '1px solid #e0e0e0',
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'white',
                        zIndex: 1
                      }}
                      onClick={(e) => e.stopPropagation()} // 阻止点击事件冒泡
                    >
                      <TextField
                        size="small"
                        placeholder="搜索分类..."
                        fullWidth
                        variant="outlined"
                        value={categorySearch}
                        onChange={(e) => {
                          setCategorySearch(e.target.value);
                        }}
                        onKeyDown={(e) => {
                          // 阻止回车键关闭下拉
                          if (e.key === 'Enter') {
                            e.stopPropagation();
                          }
                        }}
                        autoFocus
                      />
                    </div>

                    <MenuItem value="">全部</MenuItem>

                    {filteredCategories.length === 0 ? (
                      <MenuItem disabled>
                        <Typography color="textSecondary" style={{ fontStyle: 'italic' }}>
                          未找到匹配的分类
                        </Typography>
                      </MenuItem>
                    ) : (
                      filteredCategories.map(category => (
                        <MenuItem
                          key={category.id}
                          value={String(category.id)}
                          style={{
                            paddingLeft: 20 + category.level * 20,
                            fontWeight: category.level === 0 ? 'bold' : 'normal',
                            backgroundColor: category.level === 0 ? '#f5f5f5' : 'transparent'
                          }}
                        >
                          {category.displayName}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, name, cover, merchant, sectionId, supplierId, points, pointsMer, createdAt, price, buyCount, stock, order, status, specType } = row;
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, id)}
                            />
                          </TableCell> */}
                        <TableCell align="left">{id}</TableCell>
                        <TableCell align="left">{sectionMap[sectionId]}</TableCell>
                        <TableCell align="left">{supplierMap[supplierId]}</TableCell>
                        <TableCell align="left">
                          <CellImage src={cover} />
                        </TableCell>
                        <TableCell align="left">
                          <Typography color="primary" fontSize={14} sx={{ display: "inline" }}>
                            【{["单规格", "多规格"][specType]}】
                          </Typography>
                          {name}
                        </TableCell>
                        <TableCell align="left">{merchant && <MerchantInfo {...merchant} />}</TableCell>
                        <TableCell align="left">{price}</TableCell>
                        {/* <TableCell align="left">{points}</TableCell>
                        <TableCell align="left">{pointsMer}</TableCell> */}
                        <TableCell align="left">{buyCount}</TableCell>
                        <TableCell align="left">{stock || "不限"}</TableCell>
                        <TableCell align="left">
                          <Switch checked={status == 1} onChange={() => toggleEnabled({ id: row.id, status: status == 1 ? 0 : 1 })} />
                        </TableCell>

                        <TableCell align="left">{order}</TableCell>
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="right">
                          <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      {(action == "add" || action == "edit") && (
        <ProductEdit
          open
          action={action}
          item={targetItem}
          onClose={() => setAction("")}
          onFinish={() => {
            getItems();
            setAction("");
          }}
        />
      )}
    </Page>
  );
}
